import { V2Empty } from '../V2Empty.jsx';

export function V2Memory({ memoryCitations = [] }) {
  if (!memoryCitations.length) return <V2Empty message="No memory references in this conversation." />;
  return (
    <div className="v2-memory" data-testid="v2-memory">
      {memoryCitations.map(({ urn, seq }, i) => (
        <div key={urn || i} className="v2-memory-row">
          <span className="v2-memory-verb">ref</span>
          <span className="v2-memory-urn dim">{urn}</span>
        </div>
      ))}
    </div>
  );
}
